<template>
  <div
    v-if="!loading"
    style="max-width: 600px"
  >
    <v-text-field
      v-model.number="$productGroup.item.cross_sell_title"
      outlined
      hide-details
      dense
      label="Названия кросс-сейл секции"
    />
    <v-row
      class="mt-4"
      no-gutters
    >
      <v-text-field
        v-model.number="$productGroup.item.cross_sell_priority"
        type="number"
        outlined
        hide-details
        dense
        label="Категория кросс-сейла"
        style="max-width: 300px"
      />
      <v-btn
        v-if="shouldShowAddButton"
        color="primary"
        class="ml-4"
        @click="create"
      >
        Добавить
      </v-btn>
    </v-row>

    <div class="mt-4">
      <v-list class="no-scrollbar">
        <v-list-item
          class="pa-0 ma-0"
          v-for="(item, index) in items"
          :key="item.id"
          @click="handleSelect(item)"
        >
          <div class="d-flex justify-start align-center">
            <div class="text-h6 font-weight-bold mr-2">{{ item.priority }}</div>
            <div
              class="text-body-2 ml-4"
              style="color: black"
              v-text="item.name || 'Отсутствует'"
            />
          </div>
        </v-list-item>
      </v-list>
    </div>
    <v-dialog
      v-model="dialog"
      max-width="450"
      persistent
    >
      <CrossSellDialogItem
        :key="selectedCrossSell?.id || 'new'"
        :item="selectedCrossSell"
        :selectedIngredients="selectedIngredients"
        :loading="loadingDialog"
        @close="dialog = false"
        @update="update"
        @remove="remove"
        @added="added"
      />
    </v-dialog>
  </div>
  <div
    v-else
    align="center"
  >
    <v-progress-circular
      size="40"
      width="2"
      color="primary"
      indeterminate
    />
  </div>
</template>

<script>
  import CrossSellDialogItem from './CrossSellDialogItem.vue'
  import { CrossSell } from '@/models/crossseil.js'

  export default {
    name: 'ProductGroupCrossSellItem',
    components: { CrossSellDialogItem },
    props: {},
    data: () => ({
      crossSellPriority: null,
      selectedCrossSell: null,
      dialog: false,
      crossSellItems: [],
      crossSellModel: new CrossSell(),
      loading: true,
      loadingDialog: false
    }),
    computed: {
      items() {
        return this.crossSellItems.sort((a, b) => a.priority - b.priority)
      },
      selectedIngredients() {
        return this.crossSellItems.map(e => {
          return { ingredient: e.ingredient_id, product: e.product_id }
        })
      },
      shouldShowAddButton() {
        return !this.loading && this.$productGroup.item.cross_sell_priority > 0
      },
      currentGroupData() {
        return {
          group: this.$productGroup.item.id,
          items: this.crossSellItems
        }
      }
    },
    methods: {
      create() {
        this.selectedCrossSell = null
        this.dialog = true
      },
      update(value) {
        const removeId = this.selectedCrossSell?.id

        if (removeId) {
          const index = this.crossSellItems.findIndex(item => item.id === removeId)
          if (index !== -1) {
            this.$set(this.crossSellItems, index, value)

            var crossSellNewItems = this.crossSellItems.map(e => {
              return {
                product: e.product ?? e.product_id ?? '',
                ingredient: e.ingredient ?? e.ingredient_id ?? '',
                priority: e.priority
              }
            })
            const data = {
              group: this.$productGroup.item.id,
              items: crossSellNewItems
            }

            this.sync(data, true)
          }
        }
      },
      added(value) {
        var crossSellNewItems = [...this.crossSellItems, value].map(e => {
          return {
            product: e.product ?? e.product_id ?? '',
            ingredient: e.ingredient ?? e.ingredient_id ?? '',
            priority: e.priority
          }
        })
        const data = {
          group: this.$productGroup.item.id,
          items: crossSellNewItems
        }

        this.sync(data, false)
      },
      handleSelect(value) {
        this.selectedCrossSell = value
        this.dialog = true
      },

      // методы для обновления списка кросс-сейл
      remove() {
        const removeId = this.selectedCrossSell?.id

        if (removeId) {
          this.loadingDialog = true

          this.crossSellModel
            .destroy(removeId)
            .then(_ => {
              this.$store.commit('setSnackbar', {
                color: 'green',
                text: 'Успешно удалено'
              })
            })
            .catch(e => {
              this.$store.commit('setSnackbar', {
                color: 'error',
                text: 'Ошибка удаления'
              })
            })
            .finally(() => {
              const index = this.crossSellItems.findIndex(v => v.id === removeId)
              if (index > -1) {
                this.crossSellItems.splice(index, 1)
                this.loadingDialog = false
                this.dialog = false
              }
            })
        }
      },
      sync(value, isUpdate) {
        this.loadingDialog = true

        this.crossSellModel
          .sendRequest(value, 'sync', null, 'put')

          .then(res => {
            this.crossSellItems = res.map(e => {
              return {
                id: e.id,
                name: e.ingredient.vendor_name,
                image: e.ingredient.image,
                product_id: e.product,
                ingredient_id: e.ingredient.id,
                priority: e.priority
              }
            })

            this.$store.commit('setSnackbar', {
              color: 'green',
              text: !isUpdate ? 'Успешно добавлено' : 'Успешно обновлено'
            })
          })
          .catch(e => {
            this.$store.commit('setSnackbar', {
              color: 'error',
              text: isUpdate ? 'Ошибка обновления' : 'Ошибка создания'
            })
          })
          .finally(() => {
            this.loadingDialog = false
            this.dialog = false
          })
      }
    },
    mounted() {
      this.crossSellModel
        .loadList({ group: this.$productGroup.item.id })
        .then(res => {
          this.crossSellItems = res.map(e => {
            return {
              id: e.id,
              name: e.ingredient.vendor_name,
              image: e.ingredient.image,
              product_id: e.product,
              ingredient_id: e.ingredient.id,
              priority: e.priority
            }
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
</script>

<style scoped>
  .no-scrollbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
</style>
